export default "__VITE_ASSET__CUQ1Uvp$__"